import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-kpi-card',
  templateUrl: './kpi-card.component.html',
  styleUrls: ['./kpi-card.component.scss']
})
export class KPICardComponent implements OnInit {
  @Input() title: string;
  @Input() icon: string;
  @Input() value: string;

  constructor() { }

  ngOnInit() {
  }

}
